<template>
    <div class="stateInventory responsive-menu">
      <div class="responsive-menu__child">
        <PageHeader
          title="Item Counts"
          :links="[
            { name: 'home', label: 'Home' },
            { name: 'reports', label: 'Reports' },
            { name: 'inventoryReport', label: 'Inventory' },
            {
              name: 'inventorySystemCheckItem',
              label: 'Item Counts',
            },
          ]"
          @export="exportToCsv"
          :disableExport="!reportData"
        />
        <br class="no-print" />
        <ReportFilter
          class="no-print"
          :filterByItemType="true"
          @submit-filter="performGetReport"
          :isLoading="inventoryTransactions"
        />
        <div class="report-container">
          <!-- This could be a component -->
          <div class="report-body" v-if="reportData">
            <table id="table-report">
              <thead>
                <tr class="report-body__row report-body__row--header"></tr>
                <tr>
                  <th align="left">Item Id</th>
                  <th align="left">Batch #</th>
                  <th align="right">Purchased</th>
                  <th align="right">Sold</th>
                  <th align="right">Disposed</th>
                  <th align="right">Adjusted</th>
                  <th align="right">Returned</th>
                  <th align="right">On Hand</th>
                  <th align="right">Not Posted</th>
                  <th align="right">Item PreOrder</th>
                  <th align="right">WI</th>
                  <th align="right">Available</th>
                  <th align="right">Scheduled</th>
                </tr>
              </thead>

              <tbody>
                <tr class="report-body__row"></tr>
                <tr v-for="(record, index) in reportData.records" :key="index">
                  <td>{{ record.item}}</td>
                  <td class="batch">{{ record.batchId}}</td>
                  <td align="right">{{ record.purchased}}</td>
                  <td align="right">{{ record.sold}}</td>
                  <td align="right">{{ record.disposed}}</td>
                  <td align="right">{{ record.adjusted}}</td>
                  <td align="right">{{ record.returned}}</td>
                  <td align="right">{{ record.onHand}}</td>
                  <td align="right">{{ record.notPosted}}</td>
                  <td align="right">{{ record.preorder}}</td>
                  <td align="right">{{ record.workingInventory}}</td>
                  <td align="right">{{ record.available}}</td>
                  <td align="right">{{ record.scheduled}}</td>
                </tr>
              </tbody>
              <tr class="skip-export">
                <td colspan="100%">
                  <hr class="line1" />
                </td>
              </tr>
              <tr>
                <td colspan="2">Totals</td>
                <td align="right">{{ reportData.total.purchased}}</td>
                <td align="right">{{ reportData.total.sold}}</td>
                <td align="right">{{ reportData.total.disposed}}</td>
                <td align="right">{{ reportData.total.adjusted}}</td>
                <td align="right">{{ reportData.total.returned}}</td>
                <td align="right">{{ reportData.total.onHand}}</td>
                <td align="right">{{ reportData.total.notPosted}}</td>
                <td align="right">{{ reportData.total.preorder}}</td>
                <td align="right">{{ reportData.total.workingInventory}}</td>
                <td align="right">{{ reportData.total.available}}</td>
                <td align="right">{{ reportData.total.scheduled}}</td>
              </tr>
              <tr class="skip-export"></tr>
              <tr class="skip-export">
                <td colspan="100%"><hr class="line1" /></td>
              </tr>

            </table>
          </div>
        </div>
      </div>
    </div>
  </template>

  <script>
  import PageHeader from "@/components/Header/Header.vue";
  import ReportHelper from "@/lib/report/index.js";
  import { mapActions, mapGetters } from "vuex";
  import ReportFilter from "@/components/ReportFilter/ReportFilter";
  import Utilities from "@/lib/Utilities";

  export default {
    data() {
      return {
        reportData: undefined,
        Utilities,
        reportType: undefined,
        selectedPeriod: undefined,
        selectedReportFor: undefined,
        selectedReportSaleType: undefined,
        filterDropdown: undefined,
      };
    },
    components: {
      PageHeader,
      ReportFilter,
    },
    created: function () {
      this.setPageTitle("Item Counts");
    },
    mounted: function () {
      const today = new Date();
      this.selectedPeriod = {
        from: new Date(new Date().setDate(today.getDate() - 7)),
        to: today,
      };
    },
    computed: {
      ...mapGetters({
        loadingStatus: "reports/loadingStatus",
        inventoryTransactions: "reports/inventoryTransactions",
      }),
    },
    methods: {
      ...mapActions({
        getSalesTransactions: "reports/getInventoryTransactions",
      }),
      performGetReport(filter) {
        let reportType = "inventorySystemCheckItem";
        this.getSalesTransactions({
          reportType,
          ...filter,
          positiveCallback: (data) => {
            this.reportData = data;
          },
        });
      },
      exportToCsv() {
        var table = document.getElementById("table-report");
        ReportHelper.exportToExcel(table, "inventorySystemCheckItem");
      },
    },
  };
  </script>

  <style lang="scss">
  @import "./_inventorySystemCheckItem.scss";